<template>
  <v-app class="app white">

			<v-img src="./banner.jpg" min-height="320px" max-height="480px">
        <div class="donateDiv">
          <p class="text-xs-center whiteText point6">Please visit our new site: https://mecfscanterbury.nz</p>
          <a target="_blank" href="https://mecfscanterbury.nz">
            <div class="row secondary button" style="display: flex;">
              <p class="text-xs-center point55 whiteText font-weight-bold buttonText">ME/CFS Canterbury</p>
            </div>
          </a>
        </div>
      </v-img>

			<!-- <Contact /> -->
  </v-app>
</template>

<style>
.app {
  min-width: 750px !important;
}

.donateDiv {
  width: 40%; height: 90%; min-width: 200px; margin-left: 10%;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
}
.button {
	height: 6.0vh !important; width: 23vh !important; justify-content: center; align-items: center;
}
.buttonText {
	margin-top: auto; margin-bottom: auto; text-decoration: none; line-height: 90% !important;
}
</style>


<script>
import MainMenu from './components/MainMenu'
import Contact from './components/Contact'

export default {
  name: 'App',
  components: {
    MainMenu,
    Contact
  },
  data () {
    return {
      menuItems: [
          {
            title: 'Understanding ME/CFS', subgroups: [
              { title: "Possible Causes", link: "/mecfs/causes" },
              { title: "Symptoms", link: "/mecfs/symptoms" },
              { title: "Diagnosis", link: "/mecfs/diagnosis" },
              { title: "Treatment", link: "/mecfs/treatment" },
              { title: "Management", link: "/mecfs/management" },
            ], link: '/mecfs', active: true
          },
          { title: 'About Us', subgroups: [
              { title: "Our Organisation", link: "/about/group" },
              { title: "Services", link: "/about/services" },
              { title: "Group Meetings", link: "/about/meetings" },
              { title: "Membership", link: "/about/membership" },
              { title: "Donate", link: "/about/donate" }
            ], link: '/about', active: true
          },
          { title: 'Resources', link: '/resources', active: true }
          // { title: 'Contact', link: '/contact', active: true }
      ]
    }
  }
}
</script>
